import { motion } from 'framer-motion';
import React from 'react';
import { ReactComponent as ClockIcon } from '../../Icons/clockIcon.svg';
import { ReactComponent as ReadIcon } from '../../Icons/readIcon.svg';
import '../../Styles/Blog/Blog.css';

const MilaapBlog = () => {
    return (
        <div className="blog-item-main-container flex-box">
            <motion.div className="blog-item-content-wrapper" initial={{ y: `-600%`, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.5, delay: 0.9 }}>
                <h4 className="blog-item-title">
                    <span onClick={() => window.open(`https://asguru.hashnode.dev/milaap-clone`)} className="pointer">Milaap clone</span>
                </h4>
                <p className="blog-item-brief-view flex-box">
                    <span className="flex-box pointer" onClick={() => window.open(`https://asguru.hashnode.dev/milaap-clone`)}>
                        <span className="flex-box blog-item-publish-date">Apr 19, 2021</span>
                        <span className="flex-box blog-item-minutes-of-read">
                            <ClockIcon />
                            3 min read
                        </span>
                        <span className="flex-box blog-item-number-of-views">
                            <ReadIcon />
                            22 views
                        </span>
                    </span>
                </p>
                <p onClick={() => window.open(`https://asguru.hashnode.dev/milaap-clone`)} className="pointer">
                    Milaap is a crowd funding platform me and my build clone of this wonderful website in under a week, majorly focusing on
                    raising funds and making donations. We used Razorpay payment gateway to make payments. And shared all the experience that
                    I had during building this project. Happy reading 😀.
                </p>
            </motion.div>
            <motion.div
                className="blog-item-image-wrapper flex-box pointer"
                onClick={() => window.open(`https://asguru.hashnode.dev/milaap-clone`)}
                initial={{ y: `-600%`, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.9 }}
            >
                <img className="blog-item-image-box" src={process.env.PUBLIC_URL + '/Images/milaapBlogCover.png'} alt="milaap blog" />
            </motion.div>
        </div>
    )
}

export default MilaapBlog
